import React, { Attributes } from "react";
import { ButtonToolbar,Button, InputPicker } from "rsuite";
import Modal from 'rsuite/Modal';
import { useState } from "react";
import { Paragraph } from "@rsuite/icons";
import * as TeamDB  from '../../Services/EmployeeDB';
import { EmployeeDataVM, EmployeeTeamVM } from "../../Models/ViewModels";
import  * as ProfileDB from "../../Services/EmployeeDB"; 
import { useEffect } from "react";
import { setOptions } from "react-chartjs-2/dist/utils";
import { Form } from "rsuite";
import FormControl from "rsuite/esm/FormControl";
import './EmployeeTeamsList.css'
import { ToastContainer, toast } from 'react-toastify';
import ModalTitle from "rsuite/esm/Modal/ModalTitle";
import { EmployeeTeamsList } from "./EmployeeTeamsList";
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import ModalBody from "rsuite/esm/Modal/ModalBody";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import SelectPicker from 'rsuite/SelectPicker';
import { ModalFooter } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Console } from "console";

type attributes = {
 
  type:string,
  title:string  , 
  data:EmployeeTeamVM;
  onAction: any;
  cachedData:Array<EmployeeTeamVM>;

}
export const AddEditDeleteEmployeeTeam = (props:attributes) => {
  const [team,setTeam]=useState([])
  const  [all,setAll]=useState([])
  const [subTeam,setSubTeam]=useState([])
  const [process,setProcess]=useState([])
  const[filterData,setFilterData]=useState(new Array<EmployeeTeamVM>());
 
    const[newEmployee,setNewEmployee]=useState(new EmployeeTeamVM())
  const [open, setOpen] = React.useState(true);
  const [size, setSize] = React.useState();
  const [displayEmployeeName,setDisplayEmployeeName]=useState(true)
  const [displayButton,setDisplayButton]=useState(false)
  const [loading, setLoading] = useState(true)

  const[loginid,setLoginid]=useState(GetUserLoginID())
    const ids:any=[]
    const names:any=[]
    let history = useNavigate()
    
    useEffect(() => {
      if(props.type=='edit')
      {

        setDisplayEmployeeName(false)
        setDisplayButton(true)
      }
      GetAllEmployeeId(loginid);
     
    }, []) 
    const handleClose = () =>{
      setOpen(false);
      }
  const handleEditEmployeeTeamDetail=()=>{

    if(props.type=='edit'){
      
      const filteredData=props.cachedData.filter(e=>e.EmployeeID===props.data.EmployeeID);
      var selectedall=props.data.AllocationPercent;
      var selectedbuff=props.data.BufferPercent;
      var allsum :number =0;
     var buffsum:number =0;
      
      if(filteredData!=undefined){
      filteredData.map((d:EmployeeTeamVM)=>{
      allsum=allsum + d.AllocationPercent;
      buffsum = buffsum + d.BufferPercent;
   })
  }
   var total:number=allsum+buffsum-selectedall-selectedbuff+newEmployee.AllocationPercent+newEmployee.BufferPercent;
   if(total<=100){
   ProfileDB.EditTeamDetails(newEmployee).then((result)=>{
  props.onAction();
  handleClose();
     toast.info("Updated successfully");
    })
  }
  else
  toast.error("Overall Allocation% + Buffer% is greater than 100%")
  }
  if(props.type=='add'){
    
    const filteredData=props.cachedData.filter(e=>e.EmployeeID===newEmployee.EmployeeOfficeBadgeId);
   var allsum :number =0;
   var buffsum:number =0;
   
   filteredData.map((d:EmployeeTeamVM)=>{
     allsum=allsum + d.AllocationPercent;
     buffsum = buffsum + d.BufferPercent;
   })
   
   var total:number= allsum + buffsum +newEmployee.AllocationPercent +newEmployee.BufferPercent;
 console.log(total)
    if(total<= 100){
      
 ProfileDB.AddEmployeeTeam(newEmployee).then((res)=>{
 props.onAction();
 handleClose();
  toast.success("Added successfully")
 })
}
else{
  toast.error("Overall Allocation% + Buffer% is greater than 100%")
}
  }
  if(props.type=='delete')
  {
    ProfileDB.DeleteEmployeeTeam(newEmployee.mapping_id).then((res)=>{
      props.onAction();
      handleClose();
     toast.error("Deleted successfully")
    })
  }
}

    const handleInput = (event:any) => {
    let value = event.target.type === 'number' ? +event.target.value : event.target.value;
       setNewEmployee({...newEmployee, [event.target.name]:value});
}
    const GetAllEmployeeId = (loginid:any) => {
      setNewEmployee(props.data);
      console.log(props.data)

      ProfileDB.GetEmployeeIdInfo(loginid).then(res => {
      
            if (res.data) {   
              for (let i = 0; i < res.data.info.length; i++)
              {
                 ids.push(res.data.info[i].id)
              }             
              for (let i = 0; i < res.data.info.length; i++)
              {

                 names.push(res.data.info[i].name)
              }
              setAll(res.data.info)
          setTeam(res.data.Team)
          setSubTeam(res.data.SubTeam)
          setProcess(res.data.Process)
       
      }})}
   

    if(props.type=='delete'){
      return(
      <div className="modal-container">
     <ModalHeader>
       <ModalTitle><h4>{props.title}</h4></ModalTitle>
     </ModalHeader>
     <ModalBody>
      Are you sure you want to delete {newEmployee.EmployeeName}
     </ModalBody>
     <Modal.Footer>
            <Button onClick={handleEditEmployeeTeamDetail} appearance="primary">
            Delete
            </Button>
          </Modal.Footer>
     </div>
      )
    }
    else{
    return (
      <div className="modal-container"> 
          <Modal.Header>
            <Modal.Title><h3>{props.title}</h3></Modal.Title>
          </Modal.Header>
          <Modal.Body>
          
        {
         displayEmployeeName?<ModalTitle >Name</ModalTitle>:null
        
        }
        {
        displayEmployeeName?<select id="select"   name="EmployeeOfficeBadgeId"  onChange={handleInput}>   
           <option>SELECT EMPLOYEE NAME</option>
              {
            
       all.map((all:any)=>{
  
       if(all===null)
       return<></>
       else
       return(
          <option value={all.EmployeeOfficeBadgeId}>{all.FullName}</option>
         
      )
  })
}
         </select>:<h5>{newEmployee.EmployeeName}</h5>
         }
         
        <ModalTitle id="team" >Team</ModalTitle>

        <select id="select" 
               
                  name="TeamName" 
                  value={newEmployee.TeamName}
                  onChange={handleInput}
               >
             
                           {
              team.map(team=>{
                  if(team===null)
                  return<></>
                  else
              
                  return(
                     <option value={team}>{team}</option>
                    
                  )
              })
       }
         </select>
        <ModalTitle id="SubTeam">Sub Team</ModalTitle>
        <select id="select" 
        name="SubTeamName"
        value={newEmployee.SubTeamName}
        onChange={handleInput}
         >
        {
                subTeam.map(subTeam=>{
                    if(subTeam===null)
                    return<></>
                    else    
                    return(
                        <option value={subTeam} >{subTeam}</option>
                    )
                })
            }
        </select>
        <ModalTitle id="process">Process</ModalTitle>
        <select id="select"   
        name="ProcessName"
        value={newEmployee.ProcessName}
        onChange={handleInput}
        >
        {
                process.map(process=>{
                    if(process===null)
                    return<></>
                    else
                    return(
                       <option value={process}>{process}</option>
                    )
            })
          }
        </select>
        <ModalTitle id="Allper" >Allocation percentage</ModalTitle>
         <input id="select" 
         name="AllocationPercent"
        type="number"
         value={newEmployee.AllocationPercent}
         onChange={handleInput}
          >
            
          </input>

         <ModalTitle id="Bufper">Buffer percentage</ModalTitle>

        <input id="select"  
        name="BufferPercent"
        type="number"
        value={newEmployee.BufferPercent}
        onChange={handleInput}
         >

         </input>
          </Modal.Body>
          {
           
           displayButton? <Modal.Footer>   <Button onClick={handleEditEmployeeTeamDetail} appearance="primary">
           Update
           </Button> </Modal.Footer>:<ModalFooter><Button onClick={handleEditEmployeeTeamDetail} appearance="primary">
            Add
           </Button></ModalFooter>
         
          }
         
    
          
      </div>
    );
        }   
  };
